import { render, staticRenderFns } from "./chartFour.vue?vue&type=template&id=841a306c&scoped=true"
import script from "./chartFour.vue?vue&type=script&lang=js"
export * from "./chartFour.vue?vue&type=script&lang=js"
import style0 from "./chartFour.vue?vue&type=style&index=0&id=841a306c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a306c",
  null
  
)

export default component.exports